import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation, ScrollRestoration } from 'react-router-dom';
import { Toaster } from 'sonner';
import '@/App.css';

import { LanguageProvider } from '@/contexts/LanguageContext';
import Layout from '@/components/Layout';
import Home from '@/pages/Home';
import About from '@/pages/About';
import Investments from '@/pages/Investments';
import RealEstate from '@/pages/RealEstate';
import AssetManagement from '@/pages/AssetManagement';
import Contact from '@/pages/Contact';
import AdminDashboard from '@/pages/AdminDashboard';
import AuthCallback from '@/pages/AuthCallback';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, [pathname]);
  return null;
};

const AppRouter = () => {
  const location = useLocation();
  // Detect OAuth callback synchronously (URL fragment, not query params)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/investments" element={<Investments />} />
          <Route path="/real-estate" element={<RealEstate />} />
          <Route path="/asset-management" element={<AssetManagement />} />
          <Route path="/contact" element={<Contact />} />
        </Route>
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </>
  );
};

const TOAST_OPTIONS = {
  style: {
    background: '#141414',
    border: '1px solid #262626',
    color: '#fff',
    borderRadius: 0,
    fontFamily: 'Manrope, sans-serif',
  },
};

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <AppRouter />
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={TOAST_OPTIONS}
        />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
